export default __webpack_public_path__ + "static/media/bootstrap.f24fd2d9.png";